import UnHandledRejectionException from "./exceptions/UnHandledRejectionException";
import applicationErrorHandler from "./applicationErrorHandler";


export default (event) => {
    let unHandledRejectionException = new UnHandledRejectionException();

    unHandledRejectionException.message = event.reason;
    applicationErrorHandler(unHandledRejectionException);

    // the event object has two special properties:
    console.log(event.promise); // [object Promise] - the promise that generated the error
    console.log(event.reason); // Error: Whoops! - the unhandled error object
}